let Module = require('./fibs.js'); // Your Emscripten JS output file
let fib = Module().cwrap('fib', 'number', ['number']); // Call Module as a function

module.exports = fib;